import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getAllAcademicYearByStudent = async (idStudent) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/student/yearall/${idStudent}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

export const getStudentPayments = async (idStudent, idYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/studentPayment/payment/${idYear}/${idStudent}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getStudentPaymentPlan = async (idStudent, idYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/studentPaiement/${idStudent}/${idYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createStudentClaim = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/claim/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createAnswerClaim = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/answerClaim/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getStudentClaims = async (idYear, idStudent, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/claim/studentClaims/${idYear}/${idStudent}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getClaimById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/claim/getById/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
